// Meta Pixel helper.
// The single pixel instance (id 2565263507251464) is initialised once in
// public/index.html. These are thin, safe wrappers so the rest of the app can
// fire standard events without re-initialising or duplicating the pixel.

export const fbq = (...args) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args);
  }
};

// Fire a standard Meta Pixel event (PageView, ViewContent, AddToCart, InitiateCheckout, ...)
export const track = (event, params) => {
  if (params && Object.keys(params).length) {
    fbq('track', event, params);
  } else {
    fbq('track', event);
  }
};
